/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  toImageCdnSrc.ts
 */

import { ImageCdnParams } from './ImageCdnParams'
import { STATIC_CDN_URL, IMAGE_STATIC_CDN_URL, MEDIA_CDN_URL } from './settings'
import { toImageCdnSearchParams } from './toImageCdnSearchParams'

const REGEX_HAS_PROTOCOL = /^(((https?|ftp):)?\/\/|data:)/

export const toImageCdnUrl = (src: string, params?: ImageCdnParams) => {
  if (!src) {
    return undefined
  }

  const fromAssetCDN = src.startsWith(STATIC_CDN_URL)
  const fromImageCDN = src.startsWith(IMAGE_STATIC_CDN_URL)
  const fromMediaCDN = src.startsWith(MEDIA_CDN_URL)
  const noProtocol = !REGEX_HAS_PROTOCOL.test(src)

  // only convert urls for the static asset cdn or media cdn
  if (!fromAssetCDN && !fromImageCDN && !fromMediaCDN && !noProtocol) {
    return undefined
  }

  const srcUrl = noProtocol ? new URL(src, IMAGE_STATIC_CDN_URL) : new URL(src)

  if (srcUrl.pathname.endsWith('.svg')) {
    return undefined
  }

  // NOTE: we don't need to rewrite media cdn urls or image resize cdn urls
  let targetUrl: URL
  if (fromMediaCDN || fromImageCDN) {
    targetUrl = srcUrl
  } else {
    targetUrl = new URL(IMAGE_STATIC_CDN_URL)

    // preserve the pathname and search
    targetUrl.pathname = srcUrl.pathname
    targetUrl.search = srcUrl.search
  }

  // convert params to search params
  if (params) {
    const searchParams = toImageCdnSearchParams(params)
    for (const [key, value] of searchParams.entries()) {
      targetUrl.searchParams.set(key, value)
    }
  }

  return targetUrl
}
